import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ItemType } from "sprout-graphql";
import { useEffect } from "react";
import { Droppable } from "react-beautiful-dnd";
import { Box, Flex } from "sprout-ui-primitives";
import { Link } from "react-router-dom";
import useToggle from "@sprout/hooks/dist/useToggle";
import { useTopicPageViewsTopicEditor } from "../TopicPage_Views_Topic/TopicPageViewsTopicEditorContext";
const TopicPageSectionSpace = (props)=>{
    const { sectionId , sectionNodeId , sectionURL , isEmpty  } = props;
    const { state: { editor , editorPosition  } ,  } = useTopicPageViewsTopicEditor();
    /**
   * Why is this logic needed?
   * To show post editor immediately on section create
   * https://sprout.io/leaf/38023
   */ const [hide, , removeHide] = useToggle(editor === "CREATE_POST" && editorPosition === Number.MIN_SAFE_INTEGER);
    useEffect(()=>{
        if (!editor) removeHide();
    }, [
        editor,
        removeHide
    ]);
    const create = editor === "CREATE_POST" && editorPosition === sectionId;
    if (hide || create) return null;
    return /*#__PURE__*/ _jsx(Droppable, {
        type: ItemType.Post,
        droppableId: JSON.stringify({
            id: sectionId,
            nodeId: sectionNodeId,
            type: ItemType.Post,
            /**
         * NOTE: Do not delete this key.
         * This is needed because `TopicPageViewsTopicListPosts` has an indentical
         * `droppableId`. To prevent dnd issues, this needs to be unique
         */ key: "#"
        }),
        children: (dropProvided, dropSnapshot)=>{
            const { isDraggingOver  } = dropSnapshot;
            return /*#__PURE__*/ _jsxs(Box, {
                /**
             * Can't use `minHeight` here, for some reason it will cause a
             * jitter whenever the item is dragged into and out of this area
             *
             * `72px` is used when there's no branches and leaves.
             * `8px` is used when there's only branches and no leaves.
             */ height: isEmpty ? "72px" : "8px",
                // eslint-disable-next-line @typescript-eslint/unbound-method
                ref: dropProvided.innerRef,
                children: [
                    isEmpty && !isDraggingOver && /*#__PURE__*/ _jsx(Box, {
                        py: "16px",
                        children: /*#__PURE__*/ _jsx(Flex, {
                            height: "40px",
                            alignItems: "center",
                            justifyContent: "center",
                            as: Link,
                            to: sectionURL,
                            px: "16px",
                            borderRadius: "8px",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            borderColor: "black.12",
                            children: "Empty branch"
                        })
                    }),
                    dropProvided.placeholder
                ]
            });
        }
    });
};
export default TopicPageSectionSpace;
